<template>
  <div>
    <b-form @submit="onLogin">
      <b-form-group>
        <b-form-input
            id="email"
            v-model="loginForm.email"
            type="email"
            :state="apiError ? false : null"
            required
            placeholder="E-MAIL ADRESS"
            class="secondary"
            autocomplete="username">
        </b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-input
            id="password"
            v-model="loginForm.password"
            type="password"
            class="secondary"
            required
            :state="apiError ? false : null"
            placeholder="PASSWORD"
            autocomplete="current-password">
        </b-form-input>
      </b-form-group>
      <b-form-group>
        <pb-btn :busy="loggingIn" block variant="primary" type="submit"
                icon="fa-arrow-right fa-sm">
          SIGN IN
        </pb-btn>
      </b-form-group>
    </b-form>
    <b-alert class="text-left" v-if="apiError" variant="danger" show>{{ apiError }}</b-alert>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: 'login-form',
  data() {
    return {
      loggingIn: false,
      loginForm: {
        email: null,
        password: null
      }
    };
  },
  methods: {
    ...mapActions('account', ['login']),
    ...mapActions('cart', ['fetchCart']),
    ...mapActions('favorites', ['fetchFavorites']),
    ...mapActions('sample', ['fetchSampleList']),
    onLogin: function (evt) {
      evt.preventDefault();

      if (this.loginForm.email && this.loginForm.password) {
        this.loggingIn = true;
        this.login({username: this.loginForm.email, password: this.loginForm.password}).then(() => {
          if (this.user.externalData && window.LiveChatWidget) {
            window.LiveChatWidget.call('set_customer_name', this.user.firstName + ' ' + this.user.lastName);
            window.LiveChatWidget.call('set_customer_email', this.user.email);
          }

          if(this.$cookies.isKey('initialUrl')) {
            let initialUrl = this.$cookies.get('initialUrl');
            this.$cookies.remove('initialUrl');
            window.location.href = initialUrl;
          } else {
            this.$router.push('/');
          }

          this.fetchCart();
          this.fetchSampleList();
          this.fetchFavorites();

        }).finally(() => this.loggingIn = false);
      }
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
  },
  computed: {
    ...mapState('account', ['apiError', 'user']),
  }
}
</script>